import React from 'react';

interface CartItem {
  id: number;
  packageId: number;
  packageName: string;
  arrivalDate: string;
  departureDate: string;
  pricePerNight: number;
  maxPersons: number;
  totalPrice: number;
}

interface CartPageProps {
  cartItems: CartItem[];
  setCartItems: (items: CartItem[]) => void;
}

const CartPage: React.FC<CartPageProps> = ({ cartItems }) => {
  return (
    <div>
      <h2>Shopping Cart</h2>
      {cartItems.length > 0 ? (
        <ul>
          {cartItems.map((item, index) => (
            <li key={index}>
              <p>Package Name: {item.packageName}</p>
              <p>Arrival Date: {item.arrivalDate}</p>
              <p>Departure Date: {item.departureDate}</p>
              <p>Price Per Person: {item.maxPersons > 0 ? (item.totalPrice / item.maxPersons).toFixed(2) : item.totalPrice}</p>
              <p>Total Price: {item.totalPrice}</p>
            </li>
          ))}
        </ul>
      ) : (
        <p>Your cart is empty.</p>
      )}
    </div>
  );
};

export default CartPage;
